import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from "react-router-dom";
import { isLogged } from '../utils/common';
import { getDefaultRoute } from './roleWisePageRoute';

const HomeLayout = () => {
    const isLoggedIn = isLogged();
    const { newLoggedUserData } = useSelector(state => state.auth);


    if (isLoggedIn && newLoggedUserData) {
        console.log('From HomeLayout')
        const defaultRoute = getDefaultRoute({ is_onboarded: newLoggedUserData.user.is_onboarded, actions: newLoggedUserData.actions })
        return <Navigate to={defaultRoute} />
    }
    return (
        <div className="h-screen md:bg-scogof2 overflow-x-hidden">
            <Outlet />
        </div>
    )
}

export default HomeLayout;